import { Image, Container, Title, Text, Button, SimpleGrid } from '@mantine/core';
import { useNavigate } from 'react-router';
import image from '../../assets/404.svg';
import classes from './styles.module.css';
import { useTranslation } from "../../hooks/useTranslation";
import useTransientStore from "../../data/transcientStore";

export function NoPage() {
  const selectedAddressSystem = useTransientStore((state) => state.selectedAddressSystem);
  const addrIdFromStore = selectedAddressSystem?.id || 0;

  const { getTranslation } = useTranslation({ pageId: 330, addressSystemId: addrIdFromStore || 0, autoLoad: true });

	const navigate = useNavigate();

	return (
		<Container className={classes.root}>
			<SimpleGrid spacing={{ base: 40, sm: 80 }} cols={{ base: 1, sm: 2 }}>
				<Image src={image} className={classes.mobileImage} />
				<div>
					<Title className={classes.title}>
						{getTranslation("LABEL_NO_PAGE_TITLE") || "Something is not right..."}
					</Title>
					<Text c='dimmed' size='lg'>
						{getTranslation("LABEL_NO_PAGE_DESCRIPTION") ||
							"Page you are trying to open does not exist. You may have mistyped the address, or the page has been moved to another URL. If you think this is an error contact support."}
					</Text>
					<Button variant='outline' size='md' mt='xl' className={classes.control} onClick={() => navigate('/')}>
						{getTranslation("LABEL_NO_PAGE_BACK_HOME") || "Get back to home page"}
					</Button>
				</div>
				<Image src={image} className={classes.desktopImage} />
			</SimpleGrid>
		</Container>
	);
}
